import React from 'react';
import SpinnerComponent from '@teetsh/app/src/components/Spinner/ScreenSpinner';
import { ErrorPage } from '@teetsh/app/src/components/ErrorPage';
import useClassroomsQuery from '@teetsh/app/src/queries/classrooms/useClassrooms';
import { ClassroomsContext } from './context';
import { useCurrentSchoolyearIdSchoolId } from 'queries/schoolyears/atom';
import { Navigate } from 'react-router-dom';

function ClassroomsProvider(props: any) {
  const { data, isLoading, isError, error } = useClassroomsQuery();
  const { reset } = useCurrentSchoolyearIdSchoolId();

  if (error?.response?.status === 404) {
    reset();
    return <Navigate to="/" />;
  }
  if (isLoading) {
    return <SpinnerComponent />;
  }
  if (isError) {
    return <ErrorPage />;
  }
  return <ClassroomsContext.Provider value={data} {...props} />;
}

export { ClassroomsProvider };
